// Copyright 2025, University of Maryland, All Rights Reserved

export const SITE_BANNER_QUERY_KEY = ['site-banner'] as const
